import { CommonData } from '../common_schema'

export const rocksdbRWRaftData: CommonData[] = [
  {
    name: 'Write operations (timeout)',
    mean: 'raft_write_operation_timeout:total.values.mean',
    std: 'raft_write_operation_timeout:total.values.std',
    location: 'TiKV-Details --> RocksDB raft --> Write operations (timeout)'
  },
  {
    name: 'Get Duration(p99)',
    mean: 'P99_raft_get_duration:total.values.mean',
    std: 'P99_raft_get_duration:total.values.std',
    location: 'TiKV-Details --> RocksDB raft --> Get Duration'
  },
  {
    name: 'Seek Duration(p99)',
    mean: 'P99_raft_seek_duration:total.values.mean',
    std: 'P99_raft_seek_duration:total.values.std',
    location: 'TiKV-Details --> RocksDB raft --> Seek Duration'
  },
  {
    name: 'Write Duration(p99)',
    mean: 'P99_raft_write_duration:total.values.mean',
    std: 'P99_raft_write_duration:total.values.std',
    location: 'TiKV-Details --> RocksDB raft --> Write Duration'
  },
  {
    name: 'Write WAL duration(p99)',
    mean: 'P99_raft_write_wal_duration:total.values.mean',
    std: 'P99_raft_write_wal_duration:total.values.std',
    location: 'TiKV-Details --> RocksDB raft --> Write WAL duration'
  },
  {
    name: 'WAL sync duration(p99)',
    mean: 'P99_raft_wal_sync_duration:total.values.mean',
    std: 'P99_raft_wal_sync_duration:total.values.std',
    location: 'TiKV-Details --> RocksDB raft --> WAL sync duration'
  },
  {
    name: 'Bytes / Write(p99)',
    mean: 'P99_raft_bytes_write:total.values.mean',
    std: 'P99_raft_bytes_write:total.values.std',
    location: 'TiKV-Details --> RocksDB raft --> Bytes / Write'
  },
  {
    name: 'Raft write proposals(avg between TiKVs)',
    mean: 'raftstore_proposal_total:total.values.mean',
    std: 'raftstore_proposal_total:total.values.std',
    location:
      'TiKV-Details --> Raft Propose --> Raft write proposals per server'
  }
]
